export const sentryTracePropagationTargets: Array<string | RegExp> = ['localhost', /^https:\/\/.*\.joiipetcare\.com/];

export const sentryIgnoreErrors: Array<string | RegExp> = [
  'Load failed',
  'Failed to fetch',
  /NetworkError/i,
  'Network Error',
];

export function isTransientNetworkError(error: unknown): boolean {
  const message = messageFromUnknown(error);
  return /load failed|failed to fetch|networkerror|network error/i.test(message);
}

export function sentryBeforeBreadcrumb(breadcrumb: {
  category?: string;
  data?: Record<string, unknown>;
}): typeof breadcrumb | null {
  const url = String(breadcrumb.data?.['url'] ?? '');
  if (
    breadcrumb.category === 'fetch' &&
    (url.includes('firestore.googleapis.com') || url.includes('firebaseinstallations.googleapis.com'))
  ) {
    return null;
  }
  return breadcrumb;
}

function messageFromUnknown(error: unknown): string {
  if (error == null) return '';
  if (typeof error === 'string') return error;
  if (error instanceof Error) return error.message;
  if (typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
    return error.message;
  }
  return String(error);
}
